import React from "react";
import LandingNav from "../components/Landing-Nav.js";
import FooterLanding from "../components/FooterLanding.js";
import { useNavigate } from "react-router-dom";
import { Paintbrush, Users, Link,Clock, Repeat, Calculator, Settings,
  Timer, UserCheck, ShieldCheck, BellRing } from "lucide-react";


export default function HrComponent() {
    const navigate=useNavigate();
  return (
    <>
      <LandingNav />

      {/* Hero Section */}
      <section className="font-inter bg-gray-50 py-16 px-6 lg:px-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Smart HR Management Platform
            </h1>
            <p className="text-lg text-gray-600 mb-6">
              Managing people shouldn’t be complicated. Shiftry’s HR platform
              works hand-in-hand with workforce scheduling, giving you powerful
              yet easy-to-use employee management tools.
            </p>
            {/* <div className="flex gap-4">
              <button className="bg-black text-white px-5 py-3 rounded-xl shadow hover:bg-gray-800" onClick={()=>navigate("/contact")}>
                Request a Demo
              </button>
              <button className="border border-gray-300 px-5 py-3 rounded-xl hover:bg-gray-100">
                Talk to Our Team
              </button>
            </div> */}
          </div>
          <div className="flex justify-center">
            <img
              src="/hr-dashboard.png"
              alt="Dashboard preview"
              className="rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* Why Section */}
      <section className="py-20 px-6 lg:px-20 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-12">
          Why Shiftry's HR Platform?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto">
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <Paintbrush className="w-10 h-10 mx-auto mb-4 text-blue-600" />
            <h3 className="font-semibold text-lg mb-2">Clean and Modern Design</h3>
            <p className="text-gray-600">
              Intuitive interface built for efficiency.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <Users className="w-10 h-10 mx-auto mb-4 text-green-600" />
            <h3 className="font-semibold text-lg mb-2">Manager & Staff Optimized</h3>
            <p className="text-gray-600">
              Designed for busy teams who need results fast.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <Link className="w-10 h-10 mx-auto mb-4 text-purple-600" />
            <h3 className="font-semibold text-lg mb-2">Seamless Integration</h3>
            <p className="text-gray-600">
              Works with scheduling, time tracking, and payroll.
            </p>
          </div>
        </div>
      </section>

      {/* Employee Records */}
      <section className="bg-gray-50 py-20 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              All-in-One Employee Records
            </h2>
            <p className="text-gray-600 mb-6">
              Keep everything you need to know about your team in one secure place.
            </p>
            <ul className="space-y-3 text-gray-700">
              <li>✔ Track employee details from day one to their latest promotion</li>
              <li>✔ Full job and role history across multiple sites or departments</li>
              <li>✔ Chronological pay and contract history</li>
              <li>✔ Safe storage of personal, financial, and emergency details</li>
            </ul>
          </div>
          <div className="flex justify-center">
            <img
              src="/employeerecords.png"
              alt="Employee records preview"
              className="rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* Holiday Accruals */}
      <section className="py-20 px-6 lg:px-20 text-center">
  <h2 className="text-3xl font-bold text-gray-900 mb-6">
    Automated Holiday Accruals
  </h2>
  <p className="text-gray-600 mb-12">
    Tired of manual calculations? Shiftry does it for you.
  </p>
  <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
      <Clock className="w-10 h-10 mx-auto mb-4 text-blue-600" />
      <h3 className="font-semibold mb-2">Real-time Accruals</h3>
      <p className="text-gray-600">Based on hours worked</p>
    </div>
    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
      <Repeat className="w-10 h-10 mx-auto mb-4 text-green-600" />
      <h3 className="font-semibold mb-2">Carry-over Rules</h3>
      <p className="text-gray-600">For unused leave</p>
    </div>
    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
      <Calculator className="w-10 h-10 mx-auto mb-4 text-orange-600" />
      <h3 className="font-semibold mb-2">Auto Calculation</h3>
      <p className="text-gray-600">Average working hours</p>
    </div>
    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
      <Settings className="w-10 h-10 mx-auto mb-4 text-purple-600" />
      <h3 className="font-semibold mb-2">Custom Policies</h3>
      <p className="text-gray-600">Adjustable caps and rules</p>
    </div>
  </div>
</section>


      {/* Compliance */}
      <section className="bg-gray-50 py-20 px-6 lg:px-20">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
          Compliance Without the Stress
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          <div  className="bg-green-100 p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <Timer className="w-10 h-10 mx-auto mb-4 text-green-700" />
            <h3 className="font-semibold mb-2">Working Time Checks</h3>
            <p className="text-gray-600">
              Live rota checks against working time limits.
            </p>
          </div>
          <div  className="bg-pink-100 p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <UserCheck className="w-10 h-10 mx-auto mb-4 text-pink-700" />
            <h3 className="font-semibold mb-2">Skill-Based Allocation</h3>
            <p className="text-gray-600">
              Qualification-based shift assignments.
            </p>
          </div>
          <div  className="bg-orange-100 p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <ShieldCheck className="w-10 h-10 mx-auto mb-4 text-orange-700" />
            <h3 className="font-semibold mb-2">GDPR Compliant</h3>
            <p className="text-gray-600">
              Secure document storage and data protection.
            </p>
          </div>
          <div  className="bg-blue-100 p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <BellRing className="w-10 h-10 mx-auto mb-4 text-blue-700" />
            <h3 className="font-semibold mb-2">Smart Alerts</h3>
            <p className="text-gray-600">
              Notifications for expiring certifications.
            </p>
          </div>
        </div>
      </section>

      <FooterLanding />
    </>
  );
}
